export default "__VITE_ASSET__Dfp6_LnG__"